import React from 'react';
import logo from '../assets/logo.svg';
import avatar from '../assets/profile.jpg';
// import notif from '../assets/notif-icon.svg';
import { Link } from 'react-router-dom';
// import Notifications from './Notifications';


class Nav extends React.Component{
    constructor(){
        super()
        this.state = {
            showNotif: false
        }
        this.showNotifications = this.showNotifications.bind(this)
        this.hideNotifications =  this.hideNotifications.bind(this)
    }
    showNotifications(){
        this.setState({
            showNotif: !this.state.showNotif
        })
    }
    hideNotifications(){
        this.setState({
            showNotif: false
        })
    }
    render(){
        return( 
            <div>
                <div className="nav-section">
                    <nav className="navbar fixed-top navbar-expand-sm navbar-light">
                        <div className="container">
                            <Link to="/dashboard">
                                <div className="navbar-brand">
                                  <img src={logo} width="auto" height="40" alt="" />
                                </div>
                            </Link>
                            <div className="notification-div mobile" >
                                <Link to="/profile"><img src={avatar} className="avatar" alt=""/></Link>
                                {/* <img src={notif} className="notif-icon" alt="" onClick={this.showNotifications}/>  */}
                                {/* {this.state.showNotif && <Notifications handleClose={this.hideNotifications}/>}  */}
                            </div>
                            <button className="navbar-toggler collapsed hamburger-icon" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="icon-bar top-bar"></span>
                                <span className="icon-bar middle-bar"></span>
                                <span className="icon-bar bottom-bar"></span>
                                <span className="sr-only">Toggle navigation</span>
                            </button>
                            <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                               
                                    <div className="navbar-nav mr-auto">
                                        <Link to="/dashboard"><div className="nav-item nav-link" >Dashboard</div></Link>
                                        <Link to="/submissions"><div className="nav-item nav-link" >Submissions</div></Link>
                                        <Link to="/users"><div className="nav-item nav-link" >Users</div></Link>
                                        <Link to="/appointments"><div className="nav-item nav-link" >Appointments</div></Link>
                                        {/* <div className="nav-item nav-link" >Analytics</div> */}
                                    </div>
                                    {/* <form className="form-inline my-2 my-lg-0">
                                        <input className="form-control mr-sm-2 search-bar" type="search" placeholder="Search" aria-label="Search" />
                                        <i className="fa fa-search"></i>
                                    </form>   */}
                            </div> 
                            <div className="notification-div desktop" >
                                <Link to="/profile"><img src={avatar} className="avatar" alt=""/></Link>
                                {/* <img src={notif} className="notif-icon" alt="" onClick={this.showNotifications}/>  */}
                                {/* {this.state.showNotif && <Notifications handleClose={this.hideNotifications}/>}        */}
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        );
    }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav.js